import { Module } from "wrapper6";

export default class InfoboxesGrid extends Module {

    ready(app) {

        handleBoxes();

        function closeAllBoxes() {
            const BOXES = jQuery('.mtt-infoboxes-grid__box');
            
            for (let index = 0; index < BOXES.length; index++) {
                const BOX = jQuery(BOXES[index]);
                BOX.removeClass('active')
            }
        }

        function handleBoxes() {
            jQuery('.mtt-infoboxes-grid__boxes').on('click', '.mtt-infoboxes-grid__box', function (element) {
                if (jQuery(document).width()>760) {
                    return;
                }

                let BOX = jQuery(element.currentTarget);
    
                if (BOX.hasClass('active')) {
                    BOX.removeClass('active')
    
                } else {
                    closeAllBoxes()
    
                    BOX.addClass('active');
                }
            })
        }
    }
}